/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { detectLang } from "~/i18n"

import { STATIC_CONTEXT, StaticContext } from "./globals"
import { ApiAwardsResponse } from "./types/ApiAwardsResponse"
import { ApiHomeResponse } from "./types/ApiHomeResponse"

export const api = (host: string, path: string): string => {
  const regexpIpWithPort = /:\d+$/
  const lang = detectLang(host)
  const domain = lang === "ru" ? "ru" : "com"
  const dev =
    host.includes("localhost:") ||
    regexpIpWithPort.test(host) ||
    host.includes(`test.beaversbrothers.${domain}`)

  const devUrl = `https://test.beaversbrothers.${domain}/api${path}`
  const prodUrl =
    lang === "ru" ? `https://beaversbrothers.${domain}/api${path}` : `https://dabb.pro/api${path}`
  return dev ? devUrl : prodUrl
}

const fetchData = async (host: string, path: string) => {
  const url = api(host, path)
  try {
    const data = await (await fetch(url, {})).json()
    return data
  } catch (error) {
    console.error("getPageContext(path: %o) error: %o", path, error)
    throw error
  }
}

export const getHomeData = async (host: string): Promise<StaticContext & ApiHomeResponse> => {
  const homeContext = await fetchData(host, `/home`)
  return { ...STATIC_CONTEXT, ...homeContext }
}

export const getMenuData = async (host: string) => {
  return fetchData(host, `/menu`)
}

export const getBlogsData = async (host: string) => {
  return fetchData(host, `/blog`)
}

export const getBlogData = async (host: string, slug: string) => {
  return fetchData(host, `/blog?slug=${slug}`)
}

export const getCasesData = async (host: string) => {
  return fetchData(host, `/case`)
}

export const getCaseData = async (host: string, slug: string, editor: boolean) => {
  if (editor) {
    return fetchData(host, `/case?slug=${slug}&editor=true`)
  } else {
    return fetchData(host, `/case?slug=${slug}`)
  }
}

export const getClientData = async (host: string, slug: string) => {
  return fetchData(host, `/client?slug=${slug}`)
}

export const getServicesData = async (host: string) => {
  return fetchData(host, `/featurepage`)
}

export const getServiceData = async (host: string, slug: string) => {
  return fetchData(host, `/featurepage?slug=${slug}`)
}

export const getBranchData = async (host: string, slug: string) => {
  return fetchData(host, `/branch?slug=${slug}`)
}

export const getReviewsData = async (host: string) => {
  return fetchData(host, `/review`)
}

export const getAwardsData = async (host: string): Promise<ApiAwardsResponse> => {
  return fetchData(host, `/awards`)
}
